import { connect } from 'react-redux';
import JournalPartnerTagAdminEditScreen from '../components/JournalPartnerTagAdminEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.journalPartnerTagsAdmin.get('isLoading'),
    success: state.journalPartnerTagsAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const JournalPartnerTagAdminEditScreenContainer = connect(mapStateToProps)(
  JournalPartnerTagAdminEditScreen
);

export default JournalPartnerTagAdminEditScreenContainer;
